// extracted by mini-css-extract-plugin
export default {"card":"CustomerCard_card__Eob4p","cardButtons":"CustomerCard_cardButtons__dh6tc","completeTypography":"CustomerCard_completeTypography__4YwEt"};